import script from "./FrameWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./FrameWindow.vue?vue&type=script&setup=true&lang=js"

import "./FrameWindow.vue?vue&type=style&index=0&id=f6a1436e&lang=sass"

const __exports__ = script;

export default __exports__